export const TRANSMODE_CODE_OPTIONS = [
  {
    text: 'Unknown',
    value: '-',
  },
  {
    text: 'In-branch/Office',
    value: 'A',
  },
  {
    text: 'ATM',
    value: 'B',
  },
  {
    text: 'Electronic Transaction',
    value: 'C',
  },
  {
    text: 'Other',
    value: 'F',
  },
  {
    text: 'POS',
    value: 'G',
  },
  {
    text: 'Online',
    value: 'H',
  },
  {
    text: 'Remittance',
    value: 'REM',
  },
] as const;

export type TransmodeCode =
  | (typeof TRANSMODE_CODE_OPTIONS)[number]['value']
  | '';
